import React, { useState, useEffect } from "react";
import "../../../../src/TextFamily.css";
import "../DeshBoard.css";
import FinancingOptions from "./FinancingOptions";
import FinanceProductBrand from "./FinanceProductBrand";
import BankGuarantee from "../../bankGuarantee/bankGuarantee";
import { Api } from "../../../services/httpService";
import EnbdIcon from "../../../assests/enbd-icon.png";
import MarketplaceIcon from "../../../assests/marketplace-logo.png";
import InvFinance from "../../../assests/invoice-finance-icon.png";
import RevenuFiance from "../../../assests/revenue-financing-icon.png";
import BankImg from "../../../assests/banksvg.svg";
import { Button, Spinner } from "react-bootstrap";
import { PiPencilSimpleFill } from "react-icons/pi";
import { url, subscriptionKey } from "../../../constants";
import Loader from "../Loader";
const FinancingSolutionMainScreen = () => {
  const [loading, setLoading] = useState(true);
  const [financeSolution, setFinanceSolution] = useState(null);
  const [product, setProduct] = useState(null);
  const [logoIcon, setLogoIcon] = useState({}); // ✅ not null
  const [productBrand, setProductBrand] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showBankGuaranteeForm, setShowBankGuaranteeForm] = useState(false);
  const [bgProjects, setBgProjects] = useState([]);
  const [editingBgProject, setEditingBgProject] = useState(null);

  const merchantId = localStorage.getItem("_id");

  const getFile = async (item) => {
    const tokenHeader = localStorage.getItem("_token") || "";

    if (item?.logo) {
      const logoId = item?.logo?.id;
      try {
        const fileRes = await fetch(`${url}/files/${logoId}`, {
          method: "GET",
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            Authorization: tokenHeader,
          },
          redirect: "follow",
        });

        if (fileRes.ok && fileRes.body) {
          const blob = await fileRes.blob();
          const reader = new FileReader();

          reader.onloadend = () => {
            const base64data = reader.result;
            setLogoIcon((prev) => {
              return {
                ...prev,
                [logoId]: base64data,
              };
            });
          };

          reader.readAsDataURL(blob);
        }
      } catch (err) {
        console.error(`Failed to fetch logo for platform ${logoId}:`, err);
      }
    }
  };

  useEffect(() => {
    // Simulate fetching account data
    const fetchProducts = async () => {
      try {
        const response = await Api(
          "get",
          `/product/active_products?merchantId=${merchantId}`
        );
        if (response && response.body) {
          // Bank Guarantee Project item
          const bankGuaranteeProject = {
            uniqueCode: "BG",
            typeName: "Bank Guarantee Project",
            description: "Avail Advance Payment Guarantee (APG) and Performance Bank Guarantee (PBG) support to unlock advance payments and execute projects faster without blocking full working capital.",
            logo: {
              id: "f8bdef2c-93ff-4d6e-8e8b-55cc7e27bcfb",
              fileName: "Revenue Based Financing1.png",
              fileDownloadUri: "http://venapp-backend-dev-d0gyg9b4gahbdahm.uaenorth-01.azurewebsites.net/files/f8bdef2c-93ff-4d6e-8e8b-55cc7e27bcfb",
              fileType: "image/png",
              size: 11895
            },
            countryCode: "AE",
            enabled: true,
            selectedBuyerPlatforms: []
          };

          // Add Bank Guarantee Project to the array
          const updatedFinanceSolution = [...response.body, bankGuaranteeProject];
          setFinanceSolution(updatedFinanceSolution);

          for (const item of updatedFinanceSolution) {
            getFile(item);
            if (item?.selectedBuyerPlatforms && Array.isArray(item.selectedBuyerPlatforms)) {
              for (const buyer of item.selectedBuyerPlatforms) {
                getFile(buyer);
              }
            }
          }
        } else {
          console.warn("No Product found in response.");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [selectedProduct]);

  // Fetch Bank Guarantee Projects
  useEffect(() => {
    const fetchBGProjects = async () => {
      try {
        const tokenHeader = localStorage.getItem("_token") || "";
        const response = await fetch(
          `${url}/bankGuarantee/v1/allByMerchant/${merchantId}`,
          {
            method: "GET",
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              Authorization: tokenHeader,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          const projects = data.body || [];
          
          // Fetch counterparty logos for each project
          const projectsWithLogos = await Promise.all(
            projects.map(async (project) => {
              let counterpartyLogoId = null;
              if (project.counterpartyId) {
                try {
                  // Fetch counterparty details to get logo
                  const counterpartyRes = await fetch(
                    `${url}/merchant/${merchantId}`,
                    {
                      method: "GET",
                      headers: {
                        "Ocp-Apim-Subscription-Key": subscriptionKey,
                        Authorization: tokenHeader,
                      },
                    }
                  );
                  if (counterpartyRes.ok) {
                    const merchantData = await counterpartyRes.json();
                    const counterparty = merchantData.body?.buyerPlatforms?.find(
                      (bp) => bp.id === project.counterpartyId
                    );
                    if (counterparty?.logo?.id) {
                      counterpartyLogoId = counterparty.logo.id;
                      // Fetch the logo
                      await getFile({ logo: { id: counterpartyLogoId } });
                    }
                  }
                } catch (err) {
                  console.error("Error fetching counterparty logo:", err);
                }
              }
              return {
                ...project,
                counterpartyLogoId,
              };
            })
          );

          setBgProjects(projectsWithLogos);
        }
      } catch (error) {
        console.error("Error fetching BG projects:", error);
        setBgProjects([]);
      }
    };

    fetchBGProjects();
  }, [merchantId, showBankGuaranteeForm]);

  const handleEditProduct = (item, productItem) => {
    setProduct(productItem);
    setProductBrand(true);
    setSelectedProduct(item);
    setShowModal(true);
  };

  const handleEditBGProject = async (bgProject) => {
    if (!bgProject?.id) {
      setEditingBgProject(bgProject || null);
      setShowBankGuaranteeForm(true);
      return;
    }

    setLoading(true);
    try {
      const response = await Api(
        "get",
        `/bankGuarantee/v1/${bgProject.id}`
      );

      if (response?.success && response?.body) {
        const body = response.body;
        const additionalDocs = Array.isArray(body.additionalDocumentIds)
          ? body.additionalDocumentIds
              .map((doc) => {
                const docId = doc?.docId ?? doc;
                const file = doc?.file;
                if (!docId || !file?.id) {
                  return null;
                }
                return {
                  name: file.fileName || `Document-${docId}`,
                  fileName: file.fileName,
                  fileType: file.fileType,
                  fileId: file.id,
                  docId: docId,
                };
              })
              .filter(Boolean)
          : [];

        const normalizedProject = {
          ...body,
          additionalDocuments: additionalDocs,
          additionalDocumentIds: additionalDocs.map((doc) => doc.docId),
        };

        setEditingBgProject(normalizedProject);
      } else {
        setEditingBgProject(bgProject);
      }
    } catch (error) {
      console.error("Error fetching BG project:", error);
      setEditingBgProject(bgProject);
    } finally {
      setShowBankGuaranteeForm(true);
      setLoading(false);
    }
  };

  // Check if product is Bank Guarantee Project
  const isBankGuaranteeProject = (productItem) => {
    return productItem?.uniqueCode === "BG" || productItem?.typeName === "Bank Guarantee Project";
  };

  return (
    <>
      {showBankGuaranteeForm ? (
        <BankGuarantee 
          skipLayout={true} 
          onBack={() => {
            setShowBankGuaranteeForm(false);
            setEditingBgProject(null);
          }}
          editProject={editingBgProject}
        />
      ) : !product && !productBrand ? (
        <div className="deshboard-content">
          <div className="dashboard-head pb-4 mb-2">
            <div className="container">
              <div className="company-list-content">
                <div className="row align-items-end">
                  <div className="col-7">
                    <div className="breadcrumb-section mb-3">
                      <ul class="breadcrumb">
                        <li>Financing Solution</li>
                      </ul>
                    </div>
                    <h1 className="company-title mb-2">
                      Choose Your Financing Solution
                    </h1>
                    <p className="com-sub-title">
                      Select your Preferred Product
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="company-info-box">
            {loading ? (
              <Loader />
            ) : (
              <div className="container">
                <div className="row">
                  {console.log("financeSolution", financeSolution)}
                  {financeSolution?.length > 0 &&
                    financeSolution.map((productItem) => {
                      const logoId = productItem?.logo?.id;
                      const base64data = logoId ? logoIcon[logoId] : null;
                      const isBankGuarantee = isBankGuaranteeProject(productItem);
                      const displayImage = isBankGuarantee ? BankImg : (base64data || MarketplaceIcon);
                      return (
                        <div className="col-12">
                          <div className="company-info-inner finance-solution-box d-flex align-items-end flex-wrap p-4 mb-3">
                            <div className="finance-box-img w-100">
                              {displayImage && (
                                <span className="d-inline-block px-2 py-1">
                                  <img
                                    src={displayImage}
                                    alt={productItem?.typeName}
                                    style={{ width: 86 }}
                                  />
                                </span>
                              )}
                            </div>
                            <div className="step-box-detail">
                              <h2 className="info-title mb-2">
                                {productItem?.typeName}
                              </h2>
                              <p className="info-detail-text m-0">
                                {productItem?.description}
                              </p>
                            </div>
                            <div className="info-start ms-auto">
                              {isBankGuaranteeProject(productItem) ? (
                                <Button
                                  className="d-flex align-items-center"
                                  variant="primary"
                                  onClick={() => {
                                    setShowBankGuaranteeForm(true);
                                  }}
                                >
                                  Add
                                </Button>
                              ) : (
                                <Button
                                  className="d-flex align-items-center"
                                  variant="primary"
                                  onClick={() => {
                                    setProduct(productItem);
                                    setProductBrand(true);
                                  }}
                                >
                                  Select
                                </Button>
                              )}
                            </div>
                            {isBankGuaranteeProject(productItem) && bgProjects.length > 0 && (
                              <div className="buyer-plateform-add f-product-box w-100 mt-2">
                                <p className="mb-2 pb-1">
                                  Added bank guarantee projects – tap to view or edit.
                                </p>
                                <ul className="b-product-list list-unstyled d-flex align-items-start flex-wrap mb-0">
                                  {bgProjects.map((bgProject, idx) => {
                                    const counterpartyName = bgProject.counterparty || bgProject.counterpartyName || "Unknown";
                                    const counterpartyLogoId = bgProject.counterpartyLogoId;
                                    const counterpartyLogo = counterpartyLogoId ? logoIcon[counterpartyLogoId] : null;
                                    
                                    return (
                                      <li key={bgProject.id || idx}>
                                        <div className="p-img-box d-inline-flex align-items-center px-3 py-3 justify-content-center mb-2">
                                          <img
                                            src={counterpartyLogo || MarketplaceIcon}
                                            alt={counterpartyName}
                                            style={{ width: 44 }}
                                          />
                                        </div>
                                        <div
                                          className="product-edit-name text-center"
                                          onClick={() => {
                                            handleEditBGProject(bgProject);
                                          }}
                                        >
                                          <a href="#">
                                            {bgProject.projectName || bgProject.name || "Unnamed Project"}
                                            <span>
                                              <PiPencilSimpleFill />
                                            </span>
                                          </a>
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            )}
                            {productItem?.selectedBuyerPlatforms && productItem?.selectedBuyerPlatforms.length > 0 && (
                              <div className="buyer-plateform-add f-product-box w-100 mt-2">
                                <p className="mb-2 pb-1">
                                  Added buyer platforms – tap to view or edit.
                                </p>
                                <ul className="b-product-list list-unstyled d-flex align-items-start flex-wrap mb-0">
                                  {productItem?.selectedBuyerPlatforms?.map(
                                    (item, idx) => {
                                      const buyerId = item?.logo?.id;
                                      const buyerLogo = buyerId
                                        ? logoIcon[buyerId]
                                        : null;
                                      return (
                                        <li key={idx}>
                                          <div className="p-img-box d-inline-flex align-items-center px-3 py-3 justify-content-center mb-2">
                                            <img
                                              src={buyerLogo || MarketplaceIcon}
                                              alt={item?.name || buyerId}
                                              style={{ width: 44 }}
                                            />
                                          </div>
                                          <div
                                            className="product-edit-name text-center"
                                            onClick={() => {
                                              handleEditProduct(
                                                item,
                                                productItem
                                              );
                                            }}
                                          >
                                            <a href="#">
                                              {item?.name}
                                              <span>
                                                <PiPencilSimpleFill />
                                              </span>
                                            </a>
                                          </div>
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <FinanceProductBrand
          buyer={product}
          setBuyer={setProduct}
          productBrand={productBrand}
          setProductBrand={setProductBrand}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

export default FinancingSolutionMainScreen;
